import React from "react";
import styled from "styled-components";
import { Modal } from "@redq/reuse-modal";
import AboutEnglish from "./html/en/about";
import AboutKhmer from "./html/km/about";

const HelpPageWrapper = styled.div`
  background-color: #f7f7f7;
  position: relative;
  padding: 130px 0 60px 0;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 989px) {
    padding-top: 70px;
  }
`;

export const HelpPageContainer = styled.div`
  background-color: transparent;
  padding: 0;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
  @media (min-width: 990px) {
    width: 870px;
    margin-left: auto;
    margin-right: auto;
  }

  @media (max-width: 989px) {
    padding: 30px;
  }
`;

export default function AboutScreen() {
  const lang = localStorage.getItem('lang') || 'en';

  return (
    <Modal>
      <HelpPageWrapper>
        <HelpPageContainer>

          {lang === 'km'
            ? <AboutKhmer />
            : <AboutEnglish />
          }

        </HelpPageContainer>
      </HelpPageWrapper>
    </Modal>
  );
}
